export default "__VITE_ASSET__B6IxB10q__"